import * as React from 'react';
import {connect} from "react-redux";
import qrCodeDispatch from '../../ReduxRequests/Dispatch/qrCodeDispatch';
import qrCodeState from '../../ReduxRequests/State/qrCodeState';
import authState from '../../ReduxRequests/State/authState';
import TextField from '@material-ui/core/TextField';
import IdentityInput from '../Custom/IdentityInput';
import Grid from '@material-ui/core/Grid';
import {POLICY_TYPE, STATUS} from '../../Config/appConfig';
import {Auth, CoverNote, Company, Option, InsurerId, ReduxUpdatedState} from '../../Config/dataModel';
import util from '../../Util/util';
import * as moment from 'moment';
import QRCodeDownloadable from '../Custom/QRCodeDownloadable';
import Translator from '../Translator/Translator';

const tick = require('../../resource/img/tick.svg');
const cross = require('../../resource/img/cross.svg');
const pageSpinner = require('../../resource/img/page-loading.gif');

const mapStateToProps = (state) => {
    return {
        ...qrCodeState(state),
        ...authState(state)
    }
};

interface EnquiryResultProps {
    identity: Option,
    identityNo: string,
    checksum: string,
    insurer: Option,
    result: CoverNote,
    fetchQRCode?: (ref: string, id: InsurerId) => void,
    qrCode?: ReduxUpdatedState,
    companies: Company[],
    auth?: () => Auth,
    clickClose: () => void
}

interface EnquiryResultState {
    qrCode: string,
    loading: boolean
}

class EnquiryResult extends React.Component <EnquiryResultProps, EnquiryResultState> {
    public componentMountedAt : moment.Moment = moment();

    public constructor(props: EnquiryResultProps) {
        super(props);
        this.state = {
            qrCode: '',
            loading: true
        };
    }

    public componentDidMount() {
        this.props.fetchQRCode(this.props.result.ref, util.getInsurerId(this.props.insurer.value));
    }

    public componentWillReceiveProps(nextProps: EnquiryResultProps) {
        if (nextProps.qrCode && nextProps.qrCode.updatedAt.isAfter(this.componentMountedAt) && nextProps.qrCode.value !== this.state.qrCode) {
            this.setState({
                qrCode: nextProps.qrCode.value,
                loading: false
            });
        }
    }

    public render() {
        const data = this.props.result.state.data;
        const status = util.getStatus(data.props.policyEndDate, data.status, true);
        return (
            <div className="enquiryResult">
                {this.state.loading ?
                    <img className="cmCenter enquiryPageSpinner" src={pageSpinner}/> :
                    <div>
                        <div>
                            {this.props.identityNo !== '' &&
                            <div className="cmInput cmDisabledInput">
                                <Grid item xs={12}>
                                <IdentityInput
                                    identity={this.props.identity}
                                    identityNo={this.props.identityNo}
                                    checksum={this.props.checksum}/>
                                </Grid>
                            </div>}
                            <div className="cmInput cmFormInput cmDisabledInput">
                                <TextField
                                    label={<Translator path="enquiry.form.labels.chassisNumber">Chassis Number</Translator>}
                                    value={data.props.chassisNumber}
                                    disabled={true}
                                    InputProps={{disableUnderline: true}}/>
                            </div>
                            <div className="cmInput cmFormInput cmDisabledInput">
                                <TextField
                                    label={<Translator path="enquiry.form.labels.licensePlate">License Plate Number (Optional)</Translator>}
                                    value={util.getLicense(data.props.licensePlateNumber)}
                                    disabled={true}
                                    InputProps={{disableUnderline: true}}/>
                            </div>
                            <div className="cmInput cmFormInput cmDisabledInput">
                                <Grid item xs={12}>
                                    <TextField
                                        label={<Translator path="enquiry.form.labels.insurer">Insurance Company</Translator>}
                                        value={util.getCompanyNameFromList(this.props.companies, data.props.insurerCode)}
                                        disabled={true}
                                        InputProps={{disableUnderline: true}}/>
                                </Grid>
                            </div>
                            <div className="cmInput cmFormInput cmDisabledInput enquiryResultCoverPeriod">
                                <Grid item xs={12}>
                                    <TextField
                                        label={<Translator path="enquiry.form.labels.coverPeriod">Cover Period (days)</Translator>}
                                        type="number"
                                        value={util.getDuration(moment(data.props.policyStartDate), moment(data.props.policyEndDate))}
                                        disabled={true}
                                        InputProps={{disableUnderline: true}}/>
                                </Grid>
                            </div>
                            <div className="cmInput cmFormInput cmDisabledInput">
                                <Grid item xs={12}>
                                    <TextField
                                        label={<Translator path="enquiry.form.labels.startDate">Start Date</Translator>}
                                        value={util.getFormattedDatetime(data.props.policyStartDate)}
                                        disabled={true}
                                        InputProps={{disableUnderline: true}}/>
                                </Grid>
                            </div>
                            <div className="cmInput cmFormInput cmDisabledInput">
                                <Grid item xs={12}>
                                    <TextField
                                        label={<Translator path="enquiry.form.labels.endDate">End Date</Translator>}
                                        value={util.getFormattedDatetime(data.props.policyEndDate)}
                                        disabled={true}
                                        InputProps={{disableUnderline: true}}/>
                                </Grid>
                            </div>
                            <div className="cmInput cmFormInput cmDisabledInput enquiryResultPolicyContainer">
                                <Grid className="cmDateInput" item xs={6}>
                                    <TextField
                                        label={<Translator path="enquiry.form.labels.policyType">Policy Type</Translator>}
                                        value={data.props.policyType === POLICY_TYPE.COVER_NOTE ?
                                            Translator.translate("enquiry.form.policyType.coverNote", "Cover Note") :
                                            Translator.translate("enquiry.form.policyType.policy", "Policy")}
                                        disabled={true}
                                        InputProps={{disableUnderline: true}}/>
                                </Grid>
                                <Grid className="cmDateInput" item xs={6}>
                                    <TextField
                                        label={data.props.policyType === POLICY_TYPE.COVER_NOTE ? 
                                            <Translator path="enquiry.form.labels.policyReference.coverNote">Cover Note Number</Translator> :
                                            <Translator path="enquiry.form.labels.policyReference.policy">Policy Number</Translator>}
                                        value={data.props.policyReference}
                                        disabled={true}
                                        InputProps={{disableUnderline: true}}/>
                                </Grid>
                            </div>
                            <div className={`cmInput cmFormInput cmDisabledInput ${status === STATUS.VALID ? "valid" : "invalid"}`}>
                                <img className="statusIcon" src={status === STATUS.VALID ? tick : cross}/>
                                <TextField
                                    label={<Translator path="enquiry.form.labels.status">status</Translator>}
                                    value={Translator.translate(`enquiry.form.status.${status.toLowerCase()}`, status)}
                                    disabled={true}
                                    InputProps={{disableUnderline: true}}/>
                            </div>
                            {this.state.qrCode !== '' &&
                                <QRCodeDownloadable
                                    src={`data:image/png;base64,${this.state.qrCode}`}
                                    filename={`${data.props.policyReference}.png`} />}
                        </div>
                        <div className="cmHorCenter enquiryBtnsContainer">
                            <button className="cmBtn cmCenterBtn cmBlueBtn cmBoldText" onClick={(e) => this.props.clickClose()}>
                                <Translator path="enquiry.form.btn.close">Close</Translator>
                            </button>
                        </div>
                    </div>}
            </div>
        );
    }
}

export default connect<any, any, EnquiryResultProps>(mapStateToProps, qrCodeDispatch)(EnquiryResult);



// WEBPACK FOOTER //
// ./src/Components/Enquiry/EnquiryResult.tsx